module.exports = __webpack_public_path__ + "img/screencapture-netflix-watch-81262748-2021-10-01-22_39_48.dad7e562.png";